import Icon from "@ant-design/icons";
import { JSX } from "react";
import styles from "rivals/components/shared/Gallery/GalleryModal/GalleryModal.module.scss";
import { Props } from "rivals/components/shared/Gallery/GalleryModal/GalleryModalHeader/types";
import GalleryToggle from "rivals/components/shared/Gallery/GalleryModal/GalleryToggle";
import Close from "rivals/components/shared/Icons/Close";

export default function GalleryModalHeader({
  name,
  createdAt,
  onViewChange,
  onExit,
  shareMenu,
  showSlideshow,
  showPaywall,
  summary
}: Props): JSX.Element {
  return (
    <div className={styles.header}>
      <div className={styles.info}>
        <div className={styles.name}>{name}</div>
        <div className={styles.created}>{createdAt}</div>
        {!showPaywall && <div className={styles.description}>{summary}</div>}
      </div>
      <div className={styles.actions}>
        {showPaywall && <div className={styles.overlay} />}
        <div className={styles.shareMenu}>{shareMenu}</div>
        <GalleryToggle
          onViewChange={onViewChange}
          showSlideshow={showSlideshow}
        />
        <Icon
          className={styles.actionIcon}
          component={Close}
          onClick={onExit}
          rev={""}
          style={{ fontSize: "16px" }}
        />
      </div>
    </div>
  );
}
